import { Container, Typography } from "@mui/material";
import { Grid, Box, Button } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import EuroIcon from "@mui/icons-material/Euro";
import Paper from "@mui/material/Paper";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { useStyles } from "./infocard-styles";

export const InfoCard = () => {
  const classes = useStyles();

  return (
    <>
      <Paper className={classes.paper} variant="elevation" elevation={0}>
        <Box className={classes.cardContentsWrapper}>
          <Avatar className={classes.circularAvatar}>
            <EuroIcon />
          </Avatar>

          <Typography variant="h5" className={classes.cardHeader}>
            8,504,343
          </Typography>

          <Typography className={classes.cardText}>Annual Income</Typography>

          <Typography className={classes.cardText}>
            <Avatar className={classes.percentageChangeAvatarIcon}>
              <ShowChartIcon />
            </Avatar>
            95.54%
          </Typography>
        </Box>
      </Paper>
    </>
  );
};
